import { apiPath } from './api.path';
import { instance } from './axios';

async function addCategoryAPI(params) {
  const bodyFormData = new FormData();
  if (params.image) {
    bodyFormData.append('image', params.image);
  }
  bodyFormData.append('name', params.name);
  bodyFormData.append('showinAntibiotic', params.showinAntibiotic);
  bodyFormData.append('showinDecision', params.showinDecision);
  bodyFormData.append('showinClassification', params.showinClassification);
  bodyFormData.append('showinOverview', params.showinOverview);
  bodyFormData.append('showinGuidline', params.showinGuidline);
  return instance.post(apiPath.addCategory, bodyFormData).then((response) => response.data);
}

async function updateCategoryAPI(params) {
  const bodyFormData = new FormData();
  if (params.image) {
    bodyFormData.append('image', params.image);
  }
  bodyFormData.append('name', params.name);
  bodyFormData.append('_id', params._id);
  bodyFormData.append('showinAntibiotic', params.showinAntibiotic);
  bodyFormData.append('showinDecision', params.showinDecision);
  bodyFormData.append('showinClassification', params.showinClassification);
  bodyFormData.append('showinOverview', params.showinOverview);
  bodyFormData.append('showinGuidline', params.showinGuidline);
  return instance.put(apiPath.updateCategory, bodyFormData).then((response) => response.data);
}

async function getCategoryAPI(params) {
  return instance.get(apiPath.getCategpry, params).then((response) => response.data);
}

async function deleteCategoryAPI(params) {
  return instance.delete(`${apiPath.deleteCategory}/${params}`).then((response) => response.data);
}

async function selectedCategoryAPI(params) {
  return instance.get(`${apiPath.selectedCategory}/${params}`).then((response) => response.data);
}

async function getSubCategoryAPI() {
  return instance.get(apiPath.getSubCategory).then((response) => response.data);
}

async function addSubCategoryAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('name', params.name);
  bodyFormData.append('category', params.category);
  bodyFormData.append('showInOverview', params.showInOverview);
  return instance.post(apiPath.addSubCategory, bodyFormData).then((response) => response.data);
}

async function updateSubCategoryAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('_id', params._id);
  bodyFormData.append('name', params.name);
  bodyFormData.append('category', params.category);
  bodyFormData.append('showInOverview', params.showInOverview);
  return instance.post(apiPath.updateSubCategory, bodyFormData).then((response) => response.data);
}

async function deleteSubCategoryAPI(params) {
  return instance.delete(`${apiPath.deleteSubCategory}/${params}`).then((response) => response.data);
}

async function getSubtoSubAPI(params) {
  return instance.get(`${apiPath.getSubtoSub}?parentId=${params}`).then((response) => response.data);
}

async function addSubtoSubAPI(params) {
  const data = { parentId: params.parent, childrenId: params.children, name: params.name };
  return instance.post(apiPath.addSubtoSub, data).then((response) => response.data);
}

async function getTreeListAPI(params) {
  return instance.get(`${apiPath.getTreeList}?type=${params}`).then((response) => response.data);
}

async function updateSubtoSubAPI(params) {
  const data = { _id: params.parent, name: params.name };
  return instance.put(apiPath.updateSubtoSub, data).then((response) => response.data);
}

const categoryService = {
  addCategoryAPI,
  getCategoryAPI,
  deleteCategoryAPI,
  selectedCategoryAPI,
  getSubCategoryAPI,
  addSubCategoryAPI,
  updateCategoryAPI,
  deleteSubCategoryAPI,
  updateSubCategoryAPI,
  getSubtoSubAPI,
  addSubtoSubAPI,
  getTreeListAPI,
  updateSubtoSubAPI
};
export default categoryService;
